{
  "id": "testpad",
  "name": "Test Pad",
  "kind": "pad",
  "hidden": true,
  "description": "Hidden flat proving ground used by the physics tests: gravel and tarmac strips, loose/mud/wet/grass/water patches, a 15% slope, a kicker ramp, trees and rocks.",
  "seed": 7,
  "environment": {
    "sunElevationDeg": 40, "sunAzimuthDeg": 215, "turbidity": 4, "rayleigh": 1.2,
    "fogColor": [0.72, 0.78, 0.84], "fogNear": 300, "fogFar": 2200, "heightFogDensity": 0.0, "cloudCoverage": 0.3, "exposure": 1.0
  },
  "size": 2400,
  "baseSurface": "gravel",
  "zones": [
    { "rect": [40, -1150, 120, 1150], "surface": "tarmac" },
    { "rect": [-300, -1150, -220, -400], "surface": "loose" },
    { "rect": [-300, -380, -220, -200], "surface": "mud" },
    { "rect": [-300, -180, -220, 0], "surface": "wet" },
    { "rect": [-300, 20, -220, 200], "surface": "grass" },
    { "rect": [-300, 220, -220, 260], "surface": "water" },
    { "rect": [180, -400, 420, -160], "surface": "tarmac" }
  ],
  "ramps": [{ "pos": [-120, 300], "yaw": 0, "length": 9, "width": 6, "height": 1.1 }],
  "slopes": [{ "rect": [-60, 600, -20, 700], "grade": 0.15, "surface": "gravel" }],
  "trees": [[-130, 420], [-126, 420], [-122, 420], [-118, 420], [-114, 420], [-110, 420]],
  "rocks": [[-100, 440, 0.9], [-95, 450, 1.3]],
  "spawn": { "x": -140, "z": -1000, "heading": 0 }
}
